import { render, staticRenderFns } from "./FormTemplateBank.vue?vue&type=template&id=198619b4"
import script from "./FormTemplateBank.vue?vue&type=script&lang=js"
export * from "./FormTemplateBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports